/**
 * Obtiene el ambiente actual de ejecución
 *
 * - En builds móviles (EAS): usa APP_ENV del perfil de build (eas.json)
 * - En builds web: usa EXPO_PUBLIC_APP_ENV del archivo .env
 * - En desarrollo local: usa NODE_ENV
 *
 * @returns 'production' | 'development'
 */
export const getEnvironment = (): 'production' | 'development' => {
  // Para web: Expo requiere prefijo EXPO_PUBLIC_ para variables de entorno
  if (process.env.EXPO_PUBLIC_APP_ENV) {
    return process.env.EXPO_PUBLIC_APP_ENV as 'production' | 'development'
  }

  // Para mobile: EAS usa APP_ENV sin prefijo (definido en eas.json)
  if (process.env.APP_ENV) {
    return process.env.APP_ENV as 'production' | 'development'
  }

  // Fallback a NODE_ENV para desarrollo local
  return (process.env.NODE_ENV || 'development') as 'production' | 'development'
}

/**
 * Indica si el ambiente actual es producción
 */
export const isProduction = (): boolean => getEnvironment() === 'production'

/**
 * Indica si el ambiente actual es desarrollo
 */
export const isDevelopment = (): boolean => getEnvironment() === 'development'
